<template>
  <div>
    <v-data-table
      :headers="headers"
      :loading="loading"
      :items="data"
      :items-per-page="per_page"
      :server-items-length="pagination.total"
    >
      <template v-slot:item.actions="{ item }"> </template>
      <template v-slot:item.created_at="{ item }">
        {{ item.created_at | displayDateTime }}
      </template>
      <template v-slot:item.units="{ item }">
        {{ getUnitsCount(item.units) }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn icon color="blue" @click="goToPlaylist(item)">
          <v-icon class="fas fa-external-link-alt mr-2"></v-icon>View
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'MyPlaylists',
  props: {
    per_page: {
      default: 10,
    },
    icon_only: {
      default: false,
    },
  },
  data() {
    return {
      pagination: {
        current_page: 1,
        last_page: 2,
        items_per_page: 10,
        total: 10,
      },
      headers: [
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Number of Units',
          value: 'units',
        },
        {
          text: 'Date Created',
          value: 'created_at',
        },
        {
          text: 'Actions',
          value: 'actions',
        },
      ],
      loading: {
        table: true,
      },
      data: [],
    };
  },
  created() {
    this.getContents();
  },
  methods: {
    goToPlaylist(item) {
      const routeData = this.$router.resolve({
        name: 'Playlist',
        params: { id: item.id },
      });
      window.open(routeData.href, '_blank');
    },
    getUnitsCount(units) {
      return units.length;
    },
    getContents() {
      this.loading.table = true;
      this.$http('client/lms/assigned-and-shared-contents/playlists', {
        params: {
          page: this.pagination.current_page,
          per_page: this.per_page,
        },
      }).then(({ data }) => {
        this.data = data.data;
        this.pagination.last_page = data.last_page;
        this.pagination.total = data.total;
        this.$nextTick(() => {
          this.loading.table = false;
        });
      });
    },
  },
};
</script>

<style scoped></style>
